<template>
    <div id="mobile_header" v-show="isNavDisplayable && !forceHide">
        <header>
            <b-navbar toggleable="lg">
                <router-link :to="{ name: 'HomeMenu' }" class="navbar-brand"><groomy-logo/></router-link>
                <h3 v-if="title !== ''">{{ title }}</h3>
                <b-button class="nav-link nav-light" @click="onQuickNavClick" v-if="!isNavOpen"><font-awesome-icon :icon="['far', 'stream']" /> {{ $t('header.menu') }}</b-button>
                <b-button class="nav-link nav-light" @click="onQuickNavClick" v-else><font-awesome-icon :icon="['fal', 'times']" /> {{ $t('header.fermer') }}</b-button>
            </b-navbar>
        </header>
        <div id="mobile_nav" v-show="isNavOpen">
            <div class="row mt-lg-5">
                <div v-for="menu in menus" class="col-6 mb-4" :key="menu.title">
                    <router-link
                        active-class="menuActive"
                        class="h-100 item-menu"
                        :to="menu.to"
                    >
                        <span @click="checkActive"><span>
                        <i>
                            <font-awesome-icon :icon="menu.icon" />
                        </i></span>{{ $t(menu.title) }}</span>
                    </router-link>
                </div>
            </div>
            <div class="mobile-account-section">
                <div v-if="userEmail" class="mobile-account-email">
                    <font-awesome-icon :icon="['fal', 'user']" class="mr-2" />
                    {{ userEmail }}
                </div>
                <div class="mobile-account-links">
                    <router-link :to="{ name: 'resetPassword' }" class="mobile-account-link" @click.native="$store.commit('nav/close')">
                        <font-awesome-icon :icon="['far', 'lock']" class="mr-2" />
                        {{ $t('compte.changer_mdp') }}
                    </router-link>
                    <router-link :to="{ name: 'switchLang' }" class="mobile-account-link" @click.native="$store.commit('nav/close')">
                        <font-awesome-icon :icon="['far', 'globe']" class="mr-2" />
                        {{ $t('compte.changer_langue') }}
                    </router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center logOut">
                    <a href="#" v-on:click.prevent="logout">
                    {{ $t('header.logout') }}
                        <i>
                            <font-awesome-icon :icon="['fal', 'sign-out-alt']" />
                        </i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MenusReg from '@/assets/js/menus'
import Menus from '@/assets/js/menus'
import Navigation from '@/mixins/Navigation.js'

export default {
    name: 'NavMobile',
    mixins: [Navigation],
    data() {
        return {
            menus: [],
            tablesSelected: [],
            title: '',
            userEmail: null,
            events_tab: {
                'User::AccessRightsReloaded': this.reloadMenus,
                'UserMixin::initConfigLoaded': this.refreshUserEmail,
                'NavMobile::ShowNav': (identifier) => {
                    if (!this.tablesSelected.includes(identifier)) {
                        this.tablesSelected.push(identifier)
                    }
                },
                'NavMobile::HideNav': (identifier) => {
                    const idx = this.tablesSelected.indexOf(identifier)
                    if (idx !== -1) {
                        this.tablesSelected.splice(idx, 1)
                    }
                },
            }
        }
    },
    computed: {
        forceHide() {
            return this.tablesSelected.length > 0
        },
        isNavDisplayable() {
            const parent_rights = this.$route.matched.find(record => record.meta.canDisplayNavMobile !== undefined)
            return parent_rights !== undefined ? parent_rights.meta.canDisplayNavMobile : true
        },
        isNavOpen() {
            return this.$store.state.nav.isOpen
        },
    },
    watch: {
        '$route'() {
            this.$store.commit('nav/close')
            this.$store.commit('nav/closeAdd')
            this.$store.commit('nav/closeNotifications')
            this.setTitle()
        }
    },
    created() {
        MenusReg.setInstance(this)
        this.reloadMenus()
    },
    mounted() {
        this.refreshUserEmail()
    },
    methods: {
        reloadMenus() {
            const menus = Menus.user()
            this.menus = menus.filter(menu => menu.mobile)
        },
        refreshUserEmail() {
            this.userEmail = this.getConfig('user_mail')
        },
        onQuickNavClick() {
            this.isNavOpen ? this.$store.commit('nav/close') : this.$store.commit('nav/open')
        },
        async logout() {
            await this.delogUser()
        },
        checkActive(e) {
            if (!e.path) return false
            let active = e.path.filter(path => path.classList && path.classList.contains('menuActive'))
            if (active.length > 0) {
                this.onQuickNavClick()
            }
        },
        setTitle() {
            this.title = ''
        }
    }
}
</script>
